module.exports = __webpack_public_path__ + "static/img/title6.2d7aaabc.png";